

    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '../../controlador';
    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.Pedido; }
        public get Estado() { return this.Controlador.Vista.Estado; }
        public get Cliente() { return this.Controlador.Pedido.Cliente; }
        public get Envio() { return this.Controlador.Pedido.Envio; }

        public ModoHistorial: string = '';
        public Abierto: boolean = true;

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        mounted()
        {
            this.Eventos.push( this.Controlador.Vista.onEstado.subscribe( () => { this.Iniciar(); } ) );
            this.Iniciar();
        }

        async Iniciar()
        {
            if ( this.Estado == 'iniciado' )
            {
                this.Pedido.ComprobarFacturacion();
                await this.Pedido.CargarHistorial();
                this.Refrescar();
            }
        }

        public Refresh: boolean = true;
        public Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }

